import { RelayType } from '@diritto/common/content/constants';
import { EpisodeStatus } from '@diritto/common/episode/constants';
import { RecentlyReadContentDto } from '@diritto/common/recentlyRead/dtos/recently-read.dto';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { EpisodeRelayDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { useMemo } from 'react';

export type ReadContinueOrNext = {
  position?: number;
  buttonText: string;
  readEpisodeId?: number;
  link: string;
};

export const useReadContinueOrNext = (
  content?: ContentRelayDto,
  episode?: EpisodeRelayDto,
  recentlyReadContent?: RecentlyReadContentDto,
) =>
  useMemo((): ReadContinueOrNext | undefined => {
    // 작품에 접근할 수 없다. 삐빅 에러
    if (!content || content?.relayType !== RelayType.Public) {
      return undefined;
    }

    const { firstEpisodeId } = content.episodeInfo;

    // 작품에 에피소드가 없다.
    if (!firstEpisodeId) {
      return undefined;
    }

    // 최근 읽은 에피소드에 접근 할 수 없다. -> 첫 화 보기
    // 최근 읽은 데이터가 없다. -> 첫 화 보기
    if (!episode || episode.status !== EpisodeStatus.Public || !recentlyReadContent) {
      return {
        buttonText: '첫 화 보기',
        readEpisodeId: firstEpisodeId,
        link: `/contents/${content.id}/episodes/${firstEpisodeId}`,
      };
    }

    const { nextEpisodeId } = episode.episodeViewInfo;
    const readEpisodeId = recentlyReadContent.episodeId;

    if (recentlyReadContent.position > 95 && nextEpisodeId) {
      return {
        readEpisodeId: nextEpisodeId,
        buttonText: '다음화 보기',
        position: recentlyReadContent.position,
        link: `/contents/${content.id}/episodes/${nextEpisodeId}`,
      };
    }

    return {
      buttonText: episode.volume ? `${episode.volume}화 이어보기` : '이어보기',
      readEpisodeId,
      position: recentlyReadContent.position,
      link: `/contents/${content.id}/episodes/${readEpisodeId}`,
    };
  }, [content, episode, recentlyReadContent]);
